import React from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Promotions.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyCheckAlt,
  faChartLine,
  faCreditCard,
} from "@fortawesome/free-solid-svg-icons";

function Promotions() {
  const navigate = useNavigate();

  const promotions = [
    {
      id: "loan",
      icon: faMoneyCheckAlt,
      title: "Apply for Loan",
      subtitle:
        "Get instant approval with competitive interest rates. Fast disbursement to your account.",
      action: () => navigate("/loans"),
    },
    {
      id: "fxt",
      icon: faChartLine,
      title: "Join Sky FXT",
      subtitle:
        "Access premium investment opportunities with automated trading and high returns.",
      action: () => navigate("/fxt"),
    },
    {
      id: "card",
      icon: faCreditCard,
      title: "Apply for Card",
      subtitle:
        "Get your virtual card instantly. Physical card with worldwide acceptance coming soon.",
      action: () => navigate("/my-card"),
    },
  ];

  const shuffled = [...promotions].sort(() => Math.random() - 0.5);

  return (
    <div className="promotions">
      {shuffled.map((promo) => (
        <div
          key={promo.id}
          className="promo-card"
          style={{
            borderBottom: "1px solid #645e5dff",
          }}
          onClick={() => promo.action()} 
        >
          <div
            className="promo-icon"
            style={{ background: "white" }}
          >
            <FontAwesomeIcon icon={promo.icon} />
          </div>
          <div className="promo-text">
            <div className="promo-title" style={{ color: "#f4f4f4" }}>
              {promo.title}
            </div>
            <div className="promo-subtitle">{promo.subtitle}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Promotions;
